import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Throbber from '@r1-frontend/ui-react/components/loaders/Throbber';

const colsX1 = '1fr';
const colsX2 = 'repeat(2, 1fr)';
const colsX3 = 'repeat(3, 1fr)';
const colsX4 = 'repeat(4, 1fr)';
const colsX6 = 'repeat(6, 1fr)';
const colsX12 = 'repeat(12, 1fr)';

const gridTemplateStylesMap: Record<string, Record<number, string>> = {
    'desktop': {
        // 1
        1: `
            grid-template-columns: ${colsX1};
        `,
        // 2
        2: `
            grid-template-columns: ${colsX2};
        `,
        // 3
        3: `
            grid-template-columns: ${colsX3};
        `,
        // 4
        4: `
            grid-template-columns: ${colsX4};
        `,
        // 3 + 2
        5: `
            grid-template-columns: ${colsX6};

            & > :nth-child(-n+3) { grid-column: auto / span 2; }
            & > :nth-child(n+4) { grid-column: auto / span 3; }
        `,
        // 3 + 3
        6: `
            grid-template-columns: ${colsX3};
        `,
        // 4 + 3
        7: `
            grid-template-columns: ${colsX12};

            & > :nth-child(-n+4) { grid-column: auto / span 3; }
            & > :nth-child(n+5) { grid-column: auto / span 4; }
        `,
        // 4 + 4
        8: `
            grid-template-columns: ${colsX4};
        `,
    },
    'laptop': {
        // 1
        1: `
            grid-template-columns: ${colsX1};
        `,
        // 2
        2: `
            grid-template-columns: ${colsX2};
        `,
        // 2 + 1
        3: `
            grid-template-columns: ${colsX2};

            & > :last-child { grid-column: auto / span 2; }
        `,
        // 2 + 2
        4: `
            grid-template-columns: ${colsX2};
        `,
        // 3 + 2
        5: `
            grid-template-columns: ${colsX6};

            & > :nth-child(-n+3) { grid-column: auto / span 2; }
            & > :nth-child(n+4) { grid-column: auto / span 3; }
        `,
        // 3 + 3
        6: `
            grid-template-columns: ${colsX3};
        `,
        // 3 + 2 + 2
        7: `
            grid-template-columns: ${colsX6};

            & > :nth-child(-n+3) { grid-column: auto / span 2; }
            & > :nth-child(n+4) { grid-column: auto / span 3; }
        `,
        // 3 + 3 + 2
        8: `
            grid-template-columns: ${colsX6};

            & > :nth-child(-n+6) { grid-column: auto / span 2; }
            & > :nth-child(n+7) { grid-column: auto / span 3; }
        `,
    },
    'tablet': {
        // 1
        1: `
            grid-template-columns: ${colsX1};
        `,
        // 2
        2: `
            grid-template-columns: ${colsX2};
        `,
        // 2 + 1
        3: `
            grid-template-columns: ${colsX2};

            & > :last-child { grid-column: auto / span 2; }
        `,
        // 2 + 2
        4: `
            grid-template-columns: ${colsX2};
        `,
        // 2 + 2 + 1
        5: `
            grid-template-columns: ${colsX2};

            & > :not(:last-child) { grid-column: initial; }
            & > :last-child { grid-column:  auto / span 2; }

        `,
        // 2 + 2 + 2
        6: `
            grid-template-columns: ${colsX2};

            & > :nth-child(n+0) { grid-column: initial; }
        `,
        // 2 + 2 + 2 + 1
        7: `
            grid-template-columns: ${colsX2};

            & :not(:last-child) { grid-column: initial; }
            & > :last-child { grid-column:  auto / span 2; }
        `,
        // 2 + 2 + 2 + 2
        8: `
            grid-template-columns: ${colsX2};

            & > :nth-child(n+0) { grid-column: initial; }
        `,
    },
};

export const TariffOffersContainer = styled.div<{ itemsCount: number }>`
    display: grid;
    column-gap: 16px;
    row-gap: 32px;
    width: 100%;
    justify-content: center;

    ${({ itemsCount }) => css`${gridTemplateStylesMap.desktop[itemsCount]}`};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${({ itemsCount }) => css`${gridTemplateStylesMap.laptop[itemsCount]}`};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${({ itemsCount }) => css`${gridTemplateStylesMap.tablet[itemsCount]}`};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        grid-template-columns: ${colsX1};

        & > :nth-child(n+0) {
            grid-column: initial;
        }
    }
`;

export const StyledThrobber = styled(Throbber)`
    top: '120px';
`;
